import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Avatar, Typography, Snackbar, colors } from '@mui/material';
import { getUser } from 'src/utils/Common';
import logo from 'src/assets/images/konsep_2..png'
import { isProduction } from 'src/utils/contants';

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const styles = {
  root: {},
  cover: (theme) => ({
    position: 'relative',
    height: 200,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    '&:before': {
      position: 'absolute',
      content: '" "',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundImage: 'linear-gradient(-180deg, rgba(0,0,0,0.00) 58%, rgba(0,0,0,0.32) 100%)'
    }
  }),
  changeButton: (theme) => ({
    visibility: 'hidden',
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    backgroundColor: colors.blueGrey[900],
    color: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(3),
      bottom: 'auto'
    },
    '&:hover': {
      backgroundColor: colors.blueGrey[900]
    }
  }),
  addPhotoIcon: (theme) => ({
    marginRight: theme.spacing(1)
  }),
  container: (theme) => ({
    padding: theme.spacing(2, 3),
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  }),
  avatar: (theme) => ({
    border: `2px solid ${theme.palette.common.white}`,
    height: 120,
    width: 120,
    top: -60,
    left: theme.spacing(3),
    position: 'absolute',
    bgcolor: '#FFF3E0',
    color: '#FF9800',
    fontSize: '2.25rem',
    fontWeight: 700
  }),
  details: {
    marginLeft: '136px'
  },
  actions: (theme) => ({
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1)
    },
    '& > * + *': {
      marginLeft: theme.spacing(1)
    }
  }),
  pendingButton: (theme) => ({
    color: theme.palette.common.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    }
  }),
  personAddIcon: (theme) => ({
    marginRight: theme.spacing(1)
  }),
  mailIcon: (theme) => ({
    marginRight: theme.spacing(1)
  })
};

function Header({ className, ...rest }) {
  const SessionUser = getUser();
  const user = {
    name: SessionUser.FirstName +" " +SessionUser.LastName,
    bio: SessionUser.Role == "Bölge Yöneticiliği" ? SessionUser.TopServiceShopCode + " " + SessionUser.TopServiceShopName : SessionUser.Role,
    avatar: isProduction ? 'https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/' + SessionUser.TechnicianId + '.png' : null,
    cover: logo,
    connectedStatus: 'not_connected',
    Message: SessionUser.Message
  };
  const [connectedStatus] = useState(user.connectedStatus);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [avatarError, setAvatarError] = useState(false);


  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (connectedStatus === 'pending') {
      setOpenSnackbar(true);
    }
  }, [connectedStatus]);

  return (
    <Box
      {...rest}
      className={className}
      sx={styles.root}
    >
      <Box
        sx={styles.cover}
        style={{ backgroundImage: `url(${user.cover})` }}
      >

      </Box>
      <Container
        maxWidth="lg"
        sx={styles.container}
      >
        <Avatar
          alt={user.name}
          sx={styles.avatar}
          src={!avatarError ? user.avatar : undefined}
          onError={() => setAvatarError(true)}
        >
          {getInitials(user.name)}
        </Avatar>
        <div style={styles.details}>
          <Typography
            component="h2"
            gutterBottom
            variant="overline"
          >
            {user.bio}
          </Typography>
          <Typography
            component="h1"
            variant="h4"
          >
            {user.name}
          </Typography>
        </div>

      </Container>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        autoHideDuration={6000}
        message={(
          <Typography
            color="inherit"
            variant="h6"
          >
            Sent connection request
          </Typography>
        )}
        onClose={handleSnackbarClose}
        open={openSnackbar}
      />
    </Box>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
